module.exports = __webpack_public_path__ + "images/sprites/ui/cv_btn_low_9d18072dea8b93c385dc3e09af1077a9.png";